class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quantityChange = event => this.handleQuantityChange(event);
    window.addEventListener('quantity-change', this.quantityChange);
  }

  handleQuantityChange(event) {
    const { quantity } = event.detail;
    this.productForm = this.querySelector('product-form-component form');
    if (!this.productForm) return;

    this.productForm.querySelector('input[name="quantity"]').value = quantity;
  }

  disconnectedCallback() {
    window.removeEventListener('quantity-change', this.quantityChange);
  }
}
if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.options = {
      screenSize: 'both',
    };

    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    this.productForm = document.querySelector('[data-product-form]');
    this.quickAddWrapper = this;
    this.fixedClass = 'is-fixed';
    this.minBreakpoint = this.options.screenSize === 'mobile' ? 0 : this.options.screenSize === 'desktop' ? 1024 : 0;
    this.maxBreakpoint = this.options.screenSize === 'mobile' ? 767 : this.options.screenSize === 'desktop' ? 9999 : 9999;

    this.debouncedOnScroll = () => {
      const outOfRange = window.windowWidth <= this.minBreakpoint || window.windowWidth >= this.maxBreakpoint;
      const tooShort = window.windowHeight <= 480;

      if (outOfRange || tooShort) {
        this.quickAddWrapper.classList.remove(this.fixedClass);
        document.body.style.paddingBottom = 0;
        this._observer?.disconnect();
        this._observer = null;
        return;
      }

      if (!this._observer) this._initObserver();
    };

    window.addEventListener('window:scroll', this.debouncedOnScroll);
    window.addEventListener('window:resize', this.debouncedOnScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('window:scroll', this.debouncedOnScroll);
    window.removeEventListener('window:resize', this.debouncedOnScroll);
    this._observer?.disconnect();
    this._observer = null;
  }

  _initObserver() {
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isTopVisible = entry.boundingClientRect.top <= 0;
        if (isTopVisible) {
          if (this.quickAddWrapper.classList.contains(this.fixedClass)) return;

          this.quickAddWrapper.classList.add('hiding');
          setTimeout(() => {
            this.quickAddWrapper.classList.add(this.fixedClass);
            this.quickAddWrapper.classList.remove('hiding');
          }, 500);
          setTimeout(() => {
            document.body.style.paddingBottom = `${this.quickAddWrapper.children[0].clientHeight}px`;
          }, 500);
        }
        else {
          this.quickAddWrapper.classList.remove(this.fixedClass);
          document.body.style.paddingBottom = 0;
        }
      });
    });

    this._observer.observe(this.productForm);
  }
}
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
